import React from 'react'
import PropTypes from 'prop-types'
import Iframe from './Iframe'

const Link = ({ item }) => {
  return <Iframe src={item.link_url} title="Viewer: Item" />
}

Link.propTypes = {
  item: PropTypes.object.isRequired
}

export default Link